import { format, startOfMonth, startOfWeek, endOfWeek, isAfter, addDays, addWeeks } from 'date-fns';
import { toDate } from 'date-fns-tz';

export type RepeatingAvailabilitySchedule = 'WEEKLY' | 'WEEKDAYS';

/** Matches empire-graphql createRepeatingAvailability default materialization horizons. */
export function defaultRepeatingEffectiveUntil(start: Date, schedule: RepeatingAvailabilitySchedule): Date {
  return schedule === 'WEEKLY' ? addWeeks(start, 12) : addDays(start, 89);
}

export function monthKey(d: Date): string {
  return format(startOfMonth(d), 'yyyy-MM-dd');
}

export function weekKey(d: Date): string {
  return format(startOfWeek(d), 'yyyy-MM-dd');
}

export function dayKey(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

export function generateMonths(earliest: Date, latest: Date): any {
  // generate new collections for each week
  const months = {};
  let weekStart = startOfWeek(earliest);

  while (weekStart < latest) {
    const mk = monthKey(weekStart);
    const wk = weekKey(weekStart);

    // only generate collections in the present/future, not the past
    if (weekStart.getMonth() >= earliest.getMonth() || weekStart.getFullYear() > earliest.getFullYear()) {
      if (!months[mk]) months[mk] = {};
      months[mk][wk] = {};
    }

    const weekEnd = endOfWeek(weekStart);

    // generate the same week in both months
    // availabilities will appear in each one depending on their month
    if (weekStart.getMonth() !== weekEnd.getMonth()) {
      const k = monthKey(weekEnd);
      if (!months[k]) months[k] = {};
      months[k][wk] = {};
    }

    weekStart = addDays(weekStart, 7);
  }

  return months;
}

export function showWeekHeader(monthStart: string, weekStart: string, n?: Date): boolean {
  const now = n || new Date();
  const sow = toDate(weekStart);
  const som = toDate(monthStart);
  // return sow > now && sow.month() === som.month();
  return isAfter(sow, now) && sow.getMonth() === som.getMonth();
}

export function monthHeader(monthStart: string): string {
  return format(toDate(monthStart), 'MMMM yyyy');
}

export function weekHeader(weekStart: string): string {
  const start = toDate(weekStart);
  const end = endOfWeek(start);
  return `${format(start, 'MMM d')} - ${format(end, 'MMM d')}`;
}
